var showLoading = function() {
	$('.subscription.modal').find('.spinner').show();
	$('.subscription.modal').find('.useful-datas').hide();
}

var showDatas = function() {
	$('.subscription.modal').find('.spinner').hide();
	$('.subscription.modal').find('.message').hide();
	$('.subscription.modal').find('.useful-datas').fadeIn();
}

var hideLoading = function(message) {
	$('.subscription.modal').find('.spinner').hide();
	if(undefined == message) {
		$('.subscription.modal').find('.useful-datas').show();
	} else {
		$('.subscription.modal').find('.message').text(message).show();
		
		$('.error.modal .message').html(message);
		
		$('.error.modal').fadeIn();
		$('.error.modal .close').click(function(){
			window.location.reload();
		});
		//alert(message);
	}
}

$('.subscription').on('focus', 'input', function(){
	$(this).removeClass('error-warning');
	$(this).parent().find('error-message').hide();
});

$('.remove-message').focus(function(){
	if($(this).hasClass('error-warning')) {
		$(this).removeClass('error-warning');
		$(this).val('');
		$(this).parents('div').find('.error-message').hide();
	}
});

var checkTimeout;
$('.subscription.modal').on('keyup', 'input[data-check-password]', function(){
	 $(this).removeClass('error-warning');
	var parent = $(this);
	clearTimeout(checkTimeout);
	checkTimeout = setTimeout(function(){

		var password = $('.subscription.modal input[name=password]').val();
		var check = $(parent).val();

		if(password.length == 0 || check.length == 0 || password !== check){
			parent.addClass('error-warning');   
		}
	}, 500);
});

$(document).ready(function () {
	var dataSrc = $('.subscription')[0];

	if (!dataSrc) return;

	var uid = $(dataSrc).data('user-id');
	var subid = $(dataSrc).data('subscription-id');

	$('.prev').click(function (e) {
		e.preventDefault();

		$(this)
			.parents('.section').slideUp(750)
			.prev().slideDown(750);
	});

	$('.next').click(function (e) {
		e.preventDefault();
		
		$(this).parents('.section').find('input, select').each(function (e) {
			if($(this).attr('type') == 'hidden') {
				return true;
			}

			var somethingWrong = false;

			$(this).parents('label').removeClass('error');

			if (!$(this).val().length) somethingWrong = true;

			switch ($(this).attr('type')) {
				case 'email':
					if (!/[^@]+@[^\.]{2,}\..{2,}/.test($(this).val())) {
						somethingWrong = true;
					}
					break;
				case 'password':
					var pwds = $(this).parents('.section').find('[type="password"]');
					if (pwds[0].value.length < 8 || (pwds.length == 2 && pwds[0].value != pwds[1].value)) somethingWrong = true;
					break;
				default:
					if ($(this).val().length < 2) somethingWrong = true;
			}

			if (somethingWrong) $(this).parents('label').addClass('error');
		});

		if ($(this).parents('.section').find('.error').length) return;
		
		// has intent
		var self = $(this);
		var form = $(this).parents('.useful-datas').find('form[data-secret]');
		var secret = form.data('secret');
		
		if(!secret) {
		
			var country = form.find('select[name=country]').val();
			
			switch(country.toLowerCase().trim()){
				case 'be':
				case 'fr':
					// do nothing, those countries are managed
					break;
				default:
					country = 'be';
			}
			
			window.SITE_COUNTRY = country;
			
			showSubInfos(window.STRIPE_CONFIG.profile, window.STRIPE_CONFIG.subscription);
			
			$.get('/eshop/intent', {country:country}, function(intent){
					updateForm(intent, country);
					self.parents('.section').slideUp(750)
						.next().slideDown(750);
			}, 'json');
		
		} else {
			
			$(this).parents('.section').slideUp(750)
						.next().slideDown(750);
		}
		
		return;

		
	});

	$(dataSrc).on('focus', 'input, select', function () { // HTML loads with JS later
		$(this).parent().removeClass('error');
	});

	$(document).on('keypress', function (e) {
		if (e.key == 'Enter') {
			e.preventDefault();

			if ($('.next').is(':visible')) {
				$('.next').click();
				setTimeout(function () { $('[name="cardholder"]').focus() }, 500);

				return;
			}

			$('button.continue').click();
		}
	});

	$(dataSrc).find('form').on('submit', function (e) {
		console.log($('.next').is(':visible'));
	}); // ?????
	
	var updateForm = function(intent, country) {
		var modal = $('.subscription');
		modal.find('form[data-secret]').data('secret', intent.client_secret);
		modal.find('form[data-secret]').prepend('<input type="hidden" name="country" value="' + country + '" />');
	}
	
	var showProfile = function(profile, subscription) {
		window.STRIPE_CONFIG.profile = profile;
		window.STRIPE_CONFIG.subscription = subscription;
		
		var modal = $('.subscription');

		modal.find('[data-name]').html(subscription.name);
		modal.find('[data-price]').html(subscription.price_description);
		
		var infosHTML	= '';
		
		infosHTML		+= '<input type="hidden" name="env" value="' + window.SITE_ENV + '" />';
		infosHTML		+= '<input type="hidden" name="subid" value="' + subscription.id + '" />';

		infosHTML		+= profile
							? '<p>Si vos informations ne sont pas exactes, nous vous demandons de bien vouloir les mettre à jour.</p>'
							: '<p>Si vous avez déjà un compte, <a href="/user">connectez-vous ici</a>.</p>';

		infosHTML += `
			<label for="username">
				<span>Nom d'utilisateur</span>
				<input type="text" id="username" name="username" ${profile && profile.name ? 'value="' + profile.name + '" disabled' : ''} required>
			</label>
			<label for="firstname">
				<span>Prénom</span>
				<input type="text" id="firstname" name="firstname" ${profile && profile.field_firstname ? 'value="' + profile.field_firstname + '"' : ''} required>
			</label>
			<label for="lastname">
				<span>Nom</span>
				<input type="text" id="lastname" name="lastname" ${profile && profile.field_lastname ? 'value="' + profile.field_lastname + '"' : ''} required>
			</label>
			<label for="email">
				<span>E-mail</span>
				<input type="email" id="email" name="email" ${profile && profile.mail ? 'value="' + profile.mail + '"' : ''} required>
			</label>
		`;

		if (profile) {
			infosHTML += '<input type="hidden" name="uid" value="' + profile.uid + '" />';
		} else {
			infosHTML += `
				<label for="password">
					<span>Créez votre mot de passe</span>
					<input type="password" id="password" name="password" required>
				</label>
				<label for="password_check">
					<span>Vérifiez votre mot de passe</span>
					<input type="password" id="password_check" name="password_check" required>
				</label>
			`;
		}

		infosHTML += `
			<label for="birth_day">
				<span>Date de naissance</span>

				<div class="birthdate">
					<input type="text" id="birth_day" name="birth_day" ${profile && profile.birth_day ? 'value="' + profile.birth_day + '"' : ''} required placeholder="Jour">
					<input type="text" id="birth_month" name="birth_month" ${profile && profile.birth_month ? 'value="' + profile.birth_month + '"' : ''} required placeholder="Mois">
					<input type="text" id="birth_year" name="birth_year" ${profile && profile.birth_year ? 'value="' + profile.birth_year + '"' : ''} required placeholder="Année">
				</div>
			</label>
			<label for="address">
				<span>Adresse</span>
				<input type="text" id="address" name="address" ${profile && profile.address ? 'value="' + profile.address + '"' : ''} required>
			</label>
			<label for="postal_code">
				<span>Code postal</span>
				<input type="text" id="postal_code" name="postal_code" ${profile && profile.postal_code ? 'value="' + profile.postal_code + '"' : ''} required>
			</label>
			<label for="city">
				<span>Localité</span>
				<input type="text" id="city" name="city" ${profile && profile.city ? 'value="' + profile.city + '"' : ''} required>
			</label>
			<label for="country">
				<span>Pays</span>
				<select name="country" id="country" ${profile && profile.country ? 'value="' + profile.country + '"' : ''} required>
					<option value="">Sélectionnez</option>
					<option value="be">Belgique</option>
					<option value="fr">France métropolitaine</option>
				</select>
			</label>
			
			<p class="right no-margin no-padding" >Pour les DOM-TOM et les autres pays, ou pour offrir l'abonnement à une tierce personne, rendez-vous sur <a href="https://abo.spirou.com" target="_blank" >abo.spirou.com</a></p>
		`;


		/*if(!profile) {
			infosHTML       += '<p>Si vous avez déjà un compte, <a href="/user" >connectez-vous ici</a>.</p>';

			infosHTML       += '<label><span>Prénom</span> <input type="text" required name="firstname" /></label>';
			infosHTML       += '<label><span>Nom</span> <input type="text" required name="lastname" /></label>';
			infosHTML       += '<label><span>Nom d\'utilisateur</span> <input type="text" required name="username" /></label>';
			infosHTML       += '<label><span>Email</span> <input type="email" required name="email" /></label>';
			infosHTML       += '<label><span>Créer un mot de passe</span> <input type="password" required name="password" /></label>';
			infosHTML       += '<label><span>Vérification du mot de passe</span> <input type="password" required data-check-password /></label>';

		} else {
			
			if(profile.hasOwnProperty('field_firstname') && profile.field_firstname.length > 0) {
				infosHTML       += '<label><span>Prénom</span> <strong>' + profile.field_firstname + '</strong></label>';
				infosHTML       += '<input type="hidden" name="firstname" value="' + profile.field_firstname + '" />';
			} else {
				infosHTML       += '<label><span>Prénom</span> <input type="text" required name="firstname" /></label>';
			}
			
			if(profile.hasOwnProperty('field_lastname') && profile.field_lastname.length > 0) {
				infosHTML       += '<label><span>Nom</span> <strong>' + profile.field_lastname + '</strong></label>';
				infosHTML       += '<input type="hidden" name="name" value="' + profile.field_lastname + '" />';
			} else {
				infosHTML       += '<label><span>Prénom</span> <input type="text" required name="firstname" /></label>';
			}

			infosHTML       += '<label><span>Nom d\'utilisateur</span> <strong>' + profile.name + '</strong></label>';
			infosHTML       += '<label><span>Email</span> <strong>' + profile.mail + '</strong></label>';
			
			infosHTML       += '<input type="hidden" name="username" value="' + profile.name + '" />';
			infosHTML       += '<input type="hidden" name="email" value="' + profile.mail + '" />';
			infosHTML       += '<input type="hidden" name="uid" value="' + profile.uid + '" />';
		}*/
		
		modal.find('.profile div[data-payload]').html(infosHTML);
		
		modal.fadeIn();
		modal.find('.spinner').hide();
		modal.find('.useful-datas').show();
	}
	
	var showSubInfos = function(profile, subscription) {
		
		var modal = $('.subscription');
		
		var bankHTML    = '<label><input type="text" required name="cardholder" placeholder="Nom du titulaire de la carte" /></label>';        
		modal.find('.bank div[bank-payload]').html(bankHTML);
		
		$('input[name=cardholder]').focus(function(){
			$(this).attr('style', '');
		});
		
		var stripe = Stripe(window.STRIPE_CONFIG[window.SITE_COUNTRY][window.SITE_ENV]);
		var elements = stripe.elements({
			fonts: [
				{
					cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600'
				}
			]
		});

		var cardElement = elements.create('card', {
		  style: {
			base: {
			  fontFamily: 'Montserrat',
			  fontSize: '16px',
			  fontSmoothing: 'antialiased'            
			}
		  }
		});
		
		cardElement.on('focus', function(event) {
		  $('.StripeElement').attr('style', '');
		});
		
		cardElement.mount('#card-element');
		
		modal.fadeIn();
		modal.find('.spinner').hide();
		modal.find('.useful-datas').show();
		
		function sendValidation(form) {
			
			var clientSecret = $(form).data('secret');
			
			modal.find('.spinner').show();
			modal.find('.useful-datas').css({
				height: '1px',
				opacity: 0
			});
			
			stripe.confirmCardSetup(
				clientSecret,
				{
				  payment_method: {
					card: cardElement,
					billing_details: {
					  name: $(form).find('input[name=cardholder]').val()
					},
				  }
				}
			  ).then(function(result) {
			
				if (result.error) {
					hideLoading(result.error.message);
					setTimeout(showDatas, 3000);
				} else {
					//hideLoading(result.setupIntent.payment_method);
					
					form.find('input[name=payment_method]').remove();
					form.prepend('<input type="hidden" name="payment_method" value="' + result.setupIntent.payment_method + '" />');
					
					$.post(form.attr('action'), form.serialize(), function(result){
						if (result.error) {
							hideLoading(result.error.message);
							setTimeout(showDatas, 3000);
						} else {
							var welcome = $('section.welcome');

							welcome.find('#cover').attr('src', subscription.image);

							if(result.created) {
								welcome.find('.message').html('Tu peux désormais <a href="/user">te connecter</a> pour profiter de ces super avantages&#8239;!');
							}

							modal.find('.spinner').hide();
							modal.find('.useful-datas').hide();

							welcome.fadeIn();

							var price = parseFloat(subscription.price);
							var periodicity = parseInt(subscription.periodicity);
							var total = price / (periodicity/12);

							if(subscription.promo_code == 'SPIFR50') {
								total -= (price/2);
							}
							
							if(subscription.promo_code == 'SPIFR10') {
								total -= 1000;
							}
							
							if(subscription.promo_code == 'SPIFR450C') {
								total -= 450;
							}

							total = Math.round(total)/100;

							var params = {
								'event_category': 'Subscribed',
								'event_label': subscription.tracking_name,
								'value': total
							};

							if (gtag){
								gtag('event', 'pageview', params);
							}

							if (fbq) {
								fbq('track', 'Subscribe', {
									value: total,
									currency: 'EUR',
									subscription_id: subscription.id
								});
							}
						}
					}, 'json');
				}
			});
		
		}
		
		var showValidation = function(btn, result) {
			
			if(result == undefined) result = false;
			
			var infosHTML   = '<p><strong>Mon choix :</strong> ' + subscription.name +'<br>';
				infosHTML	+= '<strong>' + subscription.price_description + '</strong><br>';
			
			if(result) {
				
				var price 		= parseInt(subscription.price);
				
				switch(result.type) {
					case '%':
					case 'prct':
					case 'pourcentage':
						var discount	= (price/100) * parseInt(result.amount);
						break;
					default :
						var discount	= parseInt(result.amount);
						break;
				}
				
				var newPrice	= ((price - discount) / 100).toFixed(2).toString().replace(".", ",");
				
				infosHTML	+= '<br><strong>' + result.message + '</strong><br>';
				infosHTML	+= '<span class="highlight" >Première période à ' + newPrice + '€ seulement !</span><br>';
				
			} 
			
			infosHTML += '</p>';
			
			$('div[data-confirmation]').html(infosHTML);
			
			$(btn)
				.parents('.section').slideUp(750)
				.next().slideDown(750);
			
		}
		
		$('.continue').click(function(){
			
			var btn = $(this);
			var form = modal.find('form[data-secret]');
			
			if($('input[name=cardholder]').val().trim().length <= 0 ){
				$('input[name=cardholder]').css('border', '1px solid red');
				return false;
			}
			
			if($('.StripeElement--empty').length > 0 ){
				$('.StripeElement').css('border', '1px solid red');
				return false;
			}
			
			if(form.find('input[data-check-password]').length > 0) {
				
				var password = form.find('input[name=password]').val();
				var check = form.find('input[data-check-password]').val();
				
				if(password.length == 0 || check.length == 0 || password !== check){
					form.find('input[name=password]').addClass('error-warning');   
				}
			}
			
			if(form.find('input[name=promocode]').length > 0 && form.find('input[name=promocode]').val().trim().length > 0) {
				var promocode = form.find('input[name=promocode]').val();
				$.get('/eshop/coupon', {coupon:promocode}, function(result){
					if(result.error) {
						form.find('input[name=promocode]').addClass('error-warning');
						form.find('.error-message').html(result.message);
						form.find('.error-message').show();
					} else {
						showValidation(btn, result);
					}
					
					form.find('.error-promo').html(result.message);
					form.find('.error-promo').show();
					
				}, 'json');
			} else {
				showValidation(btn);
			}
			
		});
		
		modal.find('form[data-secret]').off('submit').on('submit', function(evt){
			
			var form = $(this);
			sendValidation(form);
			
			evt.preventDefault();
			return false;               
		});
	}
	
	$('.subscription.modal').fadeIn();
	
	if(uid && uid > 0) {
		
		$.get('/eshop/profile', {uid:uid}, function(profile){
			$.get('/eshop/subscriptions', {subid:subid}, function(subscription){
				showProfile(profile, subscription);
				
			}, 'json');
		}, 'json');
		
	} else {
		$.get('/eshop/subscriptions', {subid:subid}, function(subscription){
			showProfile(false, subscription);
			
		}, 'json');
	}
	
	return false;
});
